import { render, staticRenderFns } from "./NotesNew.vue?vue&type=template&id=474307c1&scoped=true"
import script from "./NotesNew.vue?vue&type=script&lang=ts"
export * from "./NotesNew.vue?vue&type=script&lang=ts"
import style0 from "./NotesNew.vue?vue&type=style&index=0&id=474307c1&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "474307c1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('474307c1')) {
      api.createRecord('474307c1', component.options)
    } else {
      api.reload('474307c1', component.options)
    }
    module.hot.accept("./NotesNew.vue?vue&type=template&id=474307c1&scoped=true", function () {
      api.rerender('474307c1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/manage/contractorDetails/NotesNew.vue"
export default component.exports